import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { fetchGetFeatureFlags } from "../queries/featureFlags";
import useNetworkHeaders from "./useNetworkHeaders";
import { useKeybind } from "../features/global/hooks/useKeybind";

export function useFeatureFlag(featureName: string) {
  const headers = useNetworkHeaders();
  const featureFlagQuery = useQuery(["featureFlags", featureName], fetchGetFeatureFlags(headers));
  const isEnabled = useMemo(() => featureFlagQuery.data?.enabled, [featureFlagQuery.data]);
  return { isEnabled, isLoading: featureFlagQuery.isLoading };
}

/**
 *
 * @param featureName Feature flag
 * @param checkKeybind Resolves to true when a keyboard event should override
 */
export function useFeatureFlagWithOverride(featureName: string, checkKeybind: (e: KeyboardEvent) => boolean) {
  const [override, setOverride] = useState(false);
  const headers = useNetworkHeaders();
  const featureFlagQuery = useQuery(["featureFlags", featureName], fetchGetFeatureFlags(headers));
  const isEnabled = useMemo(() => featureFlagQuery.data?.enabled || override, [featureFlagQuery.data, override]);

  useKeybind(checkKeybind, () => {
    console.log(`Overriding ${featureName} to ON`);
    setOverride(true);
  });

  return { isEnabled };
}
